import { useContext, useEffect } from 'react';

import Toolbar from './toolbar';
import WorldMap from '../game-designer/assets/world-map';
import { GameDocumentContext } from '../../contexts/game-document';
import { useBreadcrumb } from '../../contexts/breadcrumb';
import { matchPath, useLocation } from 'react-router-dom';

const GameMap = () => {
  const [state] = useContext(GameDocumentContext);
  const { setBreadcrumb } = useBreadcrumb();
  const location = useLocation();

  useEffect(() => {
    let match = matchPath('/designer/:gameId/map/*', location.pathname);
    if (match) {
      setBreadcrumb([{ text: 'Map', to: match.pathnameBase }]);
    }

    return () => {
      setBreadcrumb([]);
    };
  }, [setBreadcrumb, location.pathname]);

  useEffect(() => {
    // Set the page title.
    document.title = `World Map - ${state.gameDocument?.name}`;
  }, [state.gameDocument?.name]);

  return (
    <>
      <Toolbar
        title={'World Map'}
        buttonHelpSupport={{
          title: 'Maps & map functions guide',
          url: 'https://forum.catalystglobal.com/t/4634'
        }}
      />
      <WorldMap />
    </>
  );
};

export default GameMap;
